/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BannerInfo = {
    ID: string;
    TITLE: string;
    EXPST: string;
    EXPEND: string;
    LURL: string;
    LTG: BannerInfo.LTG;
    EXPPRIO: number;
    PCIMG: string;
    PCIMGCROP: BannerInfo.PCIMGCROP;
    PCBGCLR: string;
    MOIMG: string;
    MOIMGCROP: BannerInfo.MOIMGCROP;
    MOBGCLR: string;
    CTXT: string;
    HTXT: string;
    STXT: string;
    TXTA: string;
    EXPSTA?: BannerInfo.EXPSTA;
    PGSTA?: BannerInfo.PGSTA;
};

export namespace BannerInfo {

    export enum LTG {
        CURRENT_TAB = 'CURRENT_TAB',
        NEW_TAB = 'NEW_TAB',
        NEW_WINDOW = 'NEW_WINDOW',
    }

    export enum PCIMGCROP {
        LEFT = 'LEFT',
        CENTER = 'CENTER',
        RIGHT = 'RIGHT',
    }

    export enum MOIMGCROP {
        LEFT = 'LEFT',
        CENTER = 'CENTER',
        RIGHT = 'RIGHT',
    }

    export enum EXPSTA {
        Y = 'Y',
        N = 'N',
    }

    export enum PGSTA {
        WAITING = 'WAITING',
        PROGRESS = 'PROGRESS',
        END = 'END',
    }


}

